module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/manage-contact/manage-contact.component.css
// module id = ./src/app/manage-contact/manage-contact.component.css
// module chunks = main